
<template>

    <div class="header">
      <h1>Our Partners</h1>
      <br>
      <p>
        We specialize in, and represent companies that further process USDA
        donated commodities into finished products for the school lunch program.
        For more information about our manufacturing partners, click on a company below to visit their website.
      </p>
    </div>

  <div class="flex-container">
    <a
      target="_blank"
      href="https://www.wildmikesultimatepizza.com/k12-team/"
      class="item"
      ><img src="../assets/logos/wildmikes.jpg"
    /></a>
    <a target="_blank" href="https://bakecrafters.com/K12" class="item"
      ><img src="../assets/logos/bakecrafters.jpg"
    /></a>
    <!-- <a target="_blank" href="http://www.goldkistfarms.com/" class="item"
      ><img src="../assets/logos/goldkist.png"
    /></a> -->
    <a target="_blank" href="https://goldcreekfoods.com//pages/k12.php" class="item"
      ><img src="../assets/logos/goldcreekfoods.jpg"
    /></a>
    <a
      target="_blank"
      href="https://www.jtmfoodgroup.com/products?channel=k-12"
      class="item"
      ><img src="../assets/logos/jtm.png"
    /></a>
    <a target="_blank" href="https://tastybrandsk12.com/" class="item"
      ><img src="../assets/logos/tastybrands.png"
    /></a>
    <a
      target="_blank"
      href="https://yangs5thtaste.com/schools-k-12/"
      class="item"
      ><img src="../assets/logos/yangs.png"
    /></a>
  </div>
</template>

<script>
// .. is an alias to /src
export default {
  name: "Partners",
  components: {},
};
</script>

<style scoped>
.flex-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;
  margin: auto;
  margin-top: 20px;
}
.item {
  flex: 0 0 auto;
  margin: 25px;
}
.header {
  margin-top: 20px;
}
</style>
